import { useEffect } from 'react'
import hljs from 'highlight.js'
import javascript from 'highlight.js/lib/languages/javascript'
import python from 'highlight.js/lib/languages/python'
import shell from 'highlight.js/lib/languages/shell'

import { useNewServerWizard } from './hooks'
import ConnectInfoStep from './wizard/connectInfoStep'
import { CreateStep } from './wizard/createStep'

// Register languages
hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('python', python)
hljs.registerLanguage('shell', shell)

// We need to get the server endpoint from the API

interface NewServerWizardProps {
  appName: string
  serverId?: string
  connectedAccountId?: string
  entityId?: string
  connectorInfoId?: string
}

export const NewServerWizard = ({
  appName,
  serverId: _serverId,
  connectedAccountId: _connectedAccountId,
  entityId: _entityId,
  connectorInfoId,
}: NewServerWizardProps) => {
  // Use our custom hook
  const {
    serverName,
    setServerName,
    limitedActions,
    setLimitedActions,
    selectedTab,
    setSelectedTab,
    serverEndpoint,
    connectedId,
    entityId,
    setEntityId,
    isLoading,
    apiKey,
    handleSubmit,
    generateCommand,
    currentStep,
    serverURL
  } = useNewServerWizard({
    appName,
    initialServerId: _serverId,
    connectedAccountId: _connectedAccountId,
    initialEntityId: _entityId,
    connectorInfoId: connectorInfoId,
  })
  // Apply syntax highlighting whenever serverEndpoint or selectedTab changes
  useEffect(() => {
    setTimeout(() => {
      const codeElements = document.querySelectorAll('code.hljs')
      codeElements.forEach((element) => {
        if ((element as HTMLElement).dataset.highlighted) {
          delete (element as HTMLElement).dataset.highlighted
        }
        hljs.highlightElement(element as HTMLElement)
      })
    }, 0)
  }, [serverEndpoint, selectedTab])

  // Render different content based on the current step
  if (currentStep === 1) {
    return (
      <CreateStep
        serverName={serverName}
        setServerName={setServerName}
        connectedId={connectedId!}
        entityId={entityId!}
        setEntityId={setEntityId}
        limitedActions={limitedActions}
        setLimitedActions={setLimitedActions}
        handleSubmit={() => void handleSubmit()}
        isLoading={isLoading}
        appName={appName}
      />
    )
  } else if (currentStep === 2) {
    return (
      <ConnectInfoStep
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        serverEndpoint={serverURL ?? ''}
        apiKey={apiKey}
        connectedId={connectedId}
        limitedActions={limitedActions}
        generateCommand={() => void generateCommand()}
      />
    )
  }

  return null
}
